import React from 'react';

const BoardLookup = React.createContext({
	tasksById: {},
	tasksByRef: {},
	assetsById: {},
	assetsByRef: {},
	userFullname: '',
	taskList: [],
	lanes: [],
	moveCard: () => {},
});

export default BoardLookup;
